const layout = {
  sideBar: {
    menu: {
      jobs: {
        title: 'Bestellungen',
        children: {
          jobs: 'Bestellungen',
        },
      },
    },
  },
};

export default layout;
